import { createContext } from 'react';

import {
  CustomColorPalette,
  ColorPalette,
} from '../../core/types/color-palette.js';

export const TimeseriesColorPaletteContext = createContext<
  ColorPalette | CustomColorPalette
>('categorical');

TimeseriesColorPaletteContext['displayName'] = 'TimeseriesColorPaletteContext';
